import PropTypes from 'prop-types';
// import { Helmet } from 'react-helmet-async'
import { forwardRef } from 'react';
// @mui
import { Container } from '@mui/system';
import usePermissions from '../hooks/usePermissions';

// ----------------------------------------------------------------------

const Page = forwardRef(({ children, title = '', meta, isLogin, ...other }, ref) => {
  const { canView } = usePermissions();

  if (!canView(title) && !isLogin) {
    return null;
  }

  return (
    <>
      {/* <Helmet>
      <title>{`${title} | ${APP_NAME}`}</title>
      {meta}
    </Helmet> */}

      <Container
        maxWidth="xl"
        ref={ref}
        sx={{
          overflowX: 'hidden',
        }}
        {...other}
      >
        {children}
      </Container>
    </>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
